import React from "react";

import {
  ChevronLink,
  Columns,
  Column,
  Heading,
  Hidden,
  MarkdownLite,
  Section,
  Stack,
  Text,
} from "@origin-digital/ods-core";

import { IconElectricity, IconUsage } from "@origin-digital/ods-icons";
import { ITiledParagraphContent } from "src/pages/Spike/types";

const iconMap = {
  electricity: IconElectricity,
  usage: IconUsage,
};

const isListItem = (text: string) => {
  return text.startsWith("/list/");
};

const generateTextOrList = (text: string, index: number) => {
  const generateList = (listString: string) => {
    const listItems = listString.split("/list/").filter((item) => item);
    return (
      <Stack space="none">
        {listItems.map((listItem, idx) => (
          <Text align="left" key={`section-${index}-${idx}`}>
            <MarkdownLite>{`• ${listItem}`}</MarkdownLite>
          </Text>
        ))}
      </Stack>
    );
  };
  return isListItem(text) ? (
    generateList(text)
  ) : (
    <Text align="left" key={`section-1-${index}`}>
      <MarkdownLite>{text}</MarkdownLite>
    </Text>
  );
};

export const ParagraphSection: React.FC<{
  content: ITiledParagraphContent;
  backgroundColor?: "grey50" | "white" | "transparent";
}> = ({ content, backgroundColor = "white" }) => (
  <Section backgroundColor={backgroundColor}>
    <Hidden above="sm">
      <Stack space="xlarge" dividers>
        {content.sections.map((section, index) => (
          <Stack space="medium" key={`section-${index}`}>
            <Columns space="xxsmall" alignY="top">
              <Column>
                <Heading variant="h3">{section.heading}</Heading>
              </Column>
              <Column width="content">
                {React.createElement(iconMap[section.icon])}
              </Column>
            </Columns>
            {section.textSection.map((text, idx) =>
              generateTextOrList(text, idx)
            )}
            {section.cta && (
              <ChevronLink href={section.cta.url}>
                {section.cta.text}
              </ChevronLink>
            )}
          </Stack>
        ))}
      </Stack>
    </Hidden>
    <Hidden below="md">
      <Stack space="xxlarge">
        <Columns>
          {content.sections.map((section, index) => (
            <Column key={`section-${index}`}>
              <Stack space="medium">
                {React.createElement(iconMap[section.icon], { size: "medium" })}
                <Heading variant="h3">{section.heading}</Heading>
                {section.textSection.map((text, idx) =>
                  generateTextOrList(text, idx)
                )}
                {section.cta && (
                  <ChevronLink href={section.cta.url}>
                    {section.cta.text}
                  </ChevronLink>
                )}
              </Stack>
            </Column>
          ))}
        </Columns>
      </Stack>
    </Hidden>
  </Section>
);
